import SimpleModal from "app/components/Modals/SimpleModal";
import SimpleModalFooter from "app/components/Modals/SimpleModalFooter";
import {
  selectAllCompanyUsersById,
  selectUpdateUserByIdStatus,
  updateUserById,
} from "app/containers/Global/slice";
import TextInput from "app/storybookComponents/Forms/TextInput";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "utils/redux/hooks";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  userAccountId: number | null;
}

const EditUserNameModal = ({
  isOpen,
  onClose,
  userAccountId,
}: Readonly<Props>) => {
  const dispatch = useAppDispatch();
  const updateUserByIdStatus = useAppSelector(selectUpdateUserByIdStatus);
  const usersById = useAppSelector(selectAllCompanyUsersById);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  useEffect(() => {
    if (userAccountId && usersById[userAccountId]) {
      setFirstName(usersById[userAccountId].firstName ?? "");
      setLastName(usersById[userAccountId].lastName ?? "");
    }
  }, [userAccountId, usersById]);

  return (
    <SimpleModal show={isOpen} onHide={onClose} title="Edit Name">
      <div className="column-gap-20px">
        <TextInput
          controlId="firstName"
          inputText={firstName}
          onTextChange={setFirstName}
          inputLabel="First Name"
          placeholder="Enter first name"
          className="column"
        />

        <TextInput
          controlId="lastName"
          inputText={lastName}
          onTextChange={setLastName}
          inputLabel="Last Name"
          placeholder="Enter last name"
          className="column"
        />
        <SimpleModalFooter
          onPrimaryButtonClick={async () => {
            if (!userAccountId) {
              return;
            }
            await dispatch(
              updateUserById({
                userAccountId,
                payload: { firstName, lastName },
              })
            );
            onClose();
          }}
          primaryButtonText="Save"
          isPrimaryButtonDisabled={
            firstName === "" ||
            lastName === "" ||
            updateUserByIdStatus === "loading"
          }
        />
      </div>
    </SimpleModal>
  );
};

export default EditUserNameModal;
